export function getAppMarketUrl({
  appId,
  versionOverrideId,
  postInstallationUrl,
}: {
  appId: string;
  versionOverrideId: string;
  postInstallationUrl: string;
}): string {
  const installerUrl = new URL('https://www.wix.com/app-installer');
  installerUrl.searchParams.set('appId', appId);
  installerUrl.searchParams.set('versionOverrideId', versionOverrideId);
  installerUrl.searchParams.set('postInstallationUrl', postInstallationUrl);

  return installerUrl.toString();
}
